/**
 * Faixa Valor Faturamento
 * @author Thacryba
 */
import {Request, Resource} from 'simpli-web-sdk'

export class FaixaValorFaturamento extends Resource {
  idFaixaValorFaturamentoPk: number = 0
  idResponsavelFk: number = 0

  nomeFaixa: string | null = null
  volumeInicial: number | null = null
  volumeFinal: number | null = null
  valorFaixa: number | null = null

  get $id() {
    return this.idFaixaValorFaturamentoPk
  }
  set $id(val) {
    this.idFaixaValorFaturamentoPk = val
  }

  reset() {
    this.nomeFaixa = null
    this.volumeInicial = null
    this.volumeFinal = null
    this.valorFaixa = null
    this.idFaixaValorFaturamentoPk = 0
    this.idResponsavelFk = 0
  }
}
